import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ScoutingEmptyState = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("scouting");

  return (
    <section className="sc-empty">
      <h3>{t("empty.title")}</h3>
      <p>{t("workspace.emptyDescription")}</p>
      <div className="sc-empty-actions">
        <Button className="sc-primary" variant="contained" onClick={() => navigate("/rankingJugadores")}>
          {t("workspace.ranking")}
        </Button>
        <Button variant="outlined" onClick={() => navigate("/estadisticas")}>
          {t("workspace.statistics")}
        </Button>
      </div>
    </section>
  );
};

export default ScoutingEmptyState;
